module.exports = __webpack_public_path__ + "img/bumble.1a2f949a.png";